import compose from 'recompose/compose';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import AddressDetail from './Address';

export default compose(
  connect(
    (state) => ({
      data: _get(state, 'customers.customerDetail.data.address', {}),
      listOfInvalidsDocuments: _get(
        state,
        'customers.customerDetail.data.listOfInvalidsDocuments',
        []
      ),
    }),
    {}
  )
)(AddressDetail);
